import Vue from 'vue'
import App from './App.vue'
import VueHead from 'vue-head'
import router from './router'
import DOMPurify from 'dompurify'
import 'babel-polyfill'

const purifyConfig = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: [
    'allow',
    'allowfullscreen',
    'frameborder',
    'scrolling',
    'src',
    'style',
    'width',
    'height',
    'loading',
    'referrerpolicy'
  ]
}

Vue.config.productionTip = false

Vue.use(VueHead)
Vue.prototype.$sanitizeHtml = function(dirty) {
  return DOMPurify.sanitize(dirty || '', purifyConfig)
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
